// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3f0iU","type":"styles_type__3kxMN","choices":"styles_choices__Kbv-X"};